var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 90,
    viewBox: "0 0 134 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.0037,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3406,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6775,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0144,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3513,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.688,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.025,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.362,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.699,
    y: 0.333374,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.0037,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3406,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6775,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0144,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3513,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.688,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.025,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.362,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.699,
    y: 14.6703,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.0037,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3406,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6775,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0144,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3513,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.688,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.025,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.362,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.699,
    y: 29.0071,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.0037,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3406,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6775,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0144,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3513,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.688,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.025,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.362,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.699,
    y: 43.3441,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.0037,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3406,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6775,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0144,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3513,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.688,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.025,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.362,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.699,
    y: 57.6811,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.0037,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3406,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6775,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0144,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3513,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.688,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.025,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.362,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.699,
    y: 72.0178,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.0037,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3406,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6775,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.0144,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3513,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.688,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.025,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.362,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.699,
    y: 86.3549,
    width: 3.58423,
    height: 3.58423,
    rx: 1.34409,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.07947b983a13e091a6d37cc9fc36a65a.svg";
export { ForwardRef as ReactComponent };